"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HostAgencyBusinessModel = exports.HostAgencyType = void 0;
var HostAgencyType;
(function (HostAgencyType) {
    HostAgencyType["Small"] = "SMALL";
    HostAgencyType["Big"] = "BIG";
})(HostAgencyType || (exports.HostAgencyType = HostAgencyType = {}));
var HostAgencyBusinessModel;
(function (HostAgencyBusinessModel) {
    HostAgencyBusinessModel["Commission"] = "commission";
    HostAgencyBusinessModel["Discount"] = "discount";
    HostAgencyBusinessModel["Intrail"] = "intrail";
})(HostAgencyBusinessModel || (exports.HostAgencyBusinessModel = HostAgencyBusinessModel = {}));
//# sourceMappingURL=HostAgencyType.js.map